import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LOGO_URL, NAV_LINKS } from './data';

export default function LandingNavbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goToSection = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav
      aria-label="Navegação principal"
      className={`absolute left-1/2 top-3 z-50 w-[min(1240px,94%)] -translate-x-1/2 rounded-2xl border border-white/10 backdrop-blur-md transition-colors duration-300 md:top-4 md:rounded-full ${
        scrolled ? 'bg-primary-600/95' : 'bg-primary-600/85'
      }`}
    >
      <div className="flex h-16 items-center justify-between px-5 md:h-20 md:pl-8 md:pr-5">
        <h1 className="m-0 flex shrink-0 items-center">
          <img src={LOGO_URL} alt="GetPoints" className="logo-glow h-10 w-auto md:h-11" />
        </h1>

        <div className="hidden items-center gap-1 lg:flex">
          {NAV_LINKS.map((link) => (
            <button
              key={link.href}
              type="button"
              onClick={() => goToSection(link.href)}
              className="cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-background-100/75 transition-colors hover:bg-white/10 hover:text-background-50"
            >
              {link.label}
            </button>
          ))}
        </div>

        <div className="hidden items-center gap-2 lg:flex">
          <button
            type="button"
            onClick={() => navigate('/premiado/login')}
            className="h-10 cursor-pointer whitespace-nowrap rounded-full border border-white/20 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-white/10"
          >
            Premiado
          </button>
          <button
            type="button"
            onClick={() => navigate('/admin/login')}
            className="h-10 cursor-pointer whitespace-nowrap rounded-full bg-background-50 px-5 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
          >
            Painel do gestor
          </button>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((value) => !value)}
          aria-label={menuOpen ? 'Fechar menu de navegação' : 'Abrir menu de navegação'}
          aria-expanded={menuOpen}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full text-background-50 transition-colors hover:bg-white/10 lg:hidden"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="px-4 pb-4 pt-1 lg:hidden">
          <div className="rounded-2xl border border-white/10 bg-primary-700/80 p-2">
            {NAV_LINKS.map((link) => (
              <button
                key={link.href}
                type="button"
                onClick={() => goToSection(link.href)}
                className="w-full cursor-pointer rounded-xl px-4 py-3 text-left text-sm font-medium text-background-100/85 transition-colors hover:bg-white/10 hover:text-background-50"
              >
                {link.label}
              </button>
            ))}
            <div className="grid grid-cols-1 gap-2 pt-2 sm:grid-cols-2">
              <button
                type="button"
                onClick={() => {
                  setMenuOpen(false);
                  navigate('/premiado/login');
                }}
                className="h-11 w-full cursor-pointer whitespace-nowrap rounded-xl border border-white/20 text-sm font-medium text-background-50 transition-colors hover:bg-white/10"
              >
                Premiado
              </button>
              <button
                type="button"
                onClick={() => {
                  setMenuOpen(false);
                  navigate('/admin/login');
                }}
                className="h-11 w-full cursor-pointer whitespace-nowrap rounded-xl bg-background-50 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
              >
                Painel do gestor
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}